const AuStates = [
    {
        code: "ACT",
        name: "Australian Capital Territory",
    },
    {
        code: "NSW",
        name: "New South Wales",
    },
    {
        code: "NT",
        name: "Northern Territory",
    },
    {
        code: "QLD",
        name: "Queensland",
    },
    {
        code: "SA",
        name: "South Australia",
    },
    {
        code: "TAS",
        name: "Tasmania",
    },
    {
        code: "VIC",
        name: "Victoria",
    },
    {
        code: "WA",
        name: "Western Australia",
    },
];

export default AuStates;
